import { useState } from "react";
import FrameOverlay from "@/components/base/FrameOverlay";
import FadeIn from "@/components/base/FadeIn";
import TiltCard from "@/components/base/TiltCard";

const polaroids = [
  {
    src: "https://readdy.ai/api/search-image?query=Radiant%20female%20tattoo%20artist%20in%20early%20thirties%20warm%20smile%20golden%20toned%20skin%20cream%20silk%20blouse%20softly%20lit%20marble%20studio%20warm%20amber%20halo%20lighting%20classical%20renaissance%20atmosphere%20editorial%20portrait%20ethereal%20angelic%20quality&width=600&height=750&seq=ap4-pol-001&orientation=portrait",
    caption: "seraphina, portrait",
    rotate: "-6deg",
    top: "0%",
    left: "0%",
    z: 3,
  },
  {
    src: "https://readdy.ai/api/search-image?query=Delicate%20fine%20line%20angel%20wing%20tattoo%20with%20subtle%20antique%20gold%20accent%20ink%20ethereal%20floating%20effect%20illuminated%20manuscript%20style%20soft%20warm%20lighting%20intricate%20ornamental%20detail%20macro%20photography%20ivory%20background&width=600&height=750&seq=ap4-pol-002&orientation=portrait",
    caption: "angel wing study",
    rotate: "5deg",
    top: "8%",
    left: "32%",
    z: 4,
  },
  {
    src: "https://readdy.ai/api/search-image?query=Fine%20line%20botanical%20tattoo%20with%20subtle%20gold%20leaf%20accents%20renaissance%20herbal%20manuscript%20inspired%20delicate%20stems%20and%20flowers%20ethereal%20quality%20warm%20amber%20lighting%20editorial%20photography%20intricate%20detail&width=600&height=600&seq=ap4-pol-003&orientation=squarish",
    caption: "botanical manuscript",
    rotate: "-3deg",
    top: "2%",
    left: "62%",
    z: 5,
  },
];

const facts = [
  { label: "Specialty", value: "Fine Line · Gold Accent" },
  { label: "Trained in", value: "Paris · Illumination Arts" },
  { label: "Practice since", value: "2014 —" },
  { label: "Waitlist", value: "8–12 months" },
];

export default function ArtistProfile4() {
  const [doorOpen, setDoorOpen] = useState(false);

  const handleEnter = () => {
    const link = document.createElement("a");
    link.href = "/artist/seraphina-dor";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <section className="bg-background-50 py-24 md:py-36 border-t border-foreground-950/10 overflow-hidden relative">
      {/* Hieroglyphic door overlay */}
      {doorOpen && (
        <div className="fixed inset-0 z-[100] pointer-events-none">
          <div className="absolute inset-y-0 left-0 w-1/2 bg-foreground-950 animate-door-left overflow-hidden">
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 opacity-40">
              {[...Array(6)].map((_, r) => (
                <div key={r} className="flex gap-6 animate-hiero-glow" style={{ animationDelay: `${r * 0.3}s` }}>
                  {[...Array(4)].map((_, c) => (
                    <span key={c} className="font-display text-4xl md:text-6xl" style={{ animationDelay: `${r * 0.3 + c * 0.1}s` , color: "#B5722E" }}>
                      {["𓂀", "𓋹", "𓆣", "𓅓"][c]}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 w-1/2 bg-foreground-950 animate-door-right overflow-hidden">
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 opacity-40">
              {[...Array(6)].map((_, r) => (
                <div key={r} className="flex gap-6 animate-hiero-glow" style={{ animationDelay: `${r * 0.3 + 0.15}s` }}>
                  {[...Array(4)].map((_, c) => (
                    <span key={c} className="font-display text-4xl md:text-6xl" style={{ animationDelay: `${r * 0.3 + c * 0.1 + 0.15}s` , color: "#B5722E" }}>
                      {["𓃭", "𓁈", "𓄿", "𓃒"][c]}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-full bg-gradient-to-b from-transparent via-accent-500/60 to-transparent animate-hiero-glow" />
          </div>
        </div>
      )}

      <div className="px-6 md:px-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          {/* Polaroid desk side */}
          <div className="col-span-12 md:col-span-7 order-2 md:order-1" data-product-shop>
            <div
              className="relative w-full bg-background-100 border border-foreground-950/15 rounded-md p-4"
              style={{ aspectRatio: "4 / 3" }}
            >
              {/* Coffee ring stain */}
              <div
                className="absolute z-10 rounded-full border-2 border-primary-500/30 pointer-events-none"
                style={{ top: "58%", left: "60%", width: "10%", aspectRatio: "1/1" }}
              />

              {polaroids.map((p, i) => (
                <FadeIn
                  key={i}
                  delay={i * 150}
                  className="absolute block cursor-pointer"
                  style={{
                    top: p.top,
                    left: p.left,
                    width: "32%",
                    zIndex: p.z,
                  }}
                >
                  <div
                    onClick={handleEnter}
                    className="group transition-all duration-500"
                    style={{ transform: `rotate(${p.rotate})` }}
                  >
                    <div className="transition-transform duration-500 group-hover:-translate-y-2 group-hover:rotate-0">
                      <TiltCard className="aspect-[4/5] overflow-hidden bg-background-100" maxTilt={10} scale={1.04}>
                        <img
                          src={p.src}
                          alt={p.caption}
                          className="w-full h-full object-cover object-top"
                        />
                        <FrameOverlay />
                      </TiltCard>
                    </div>
                  </div>
                </FadeIn>
              ))}

              <div
                className="absolute z-20 bg-background-50/70 border border-foreground-950/10 pointer-events-none"
                style={{
                  top: "4%",
                  left: "78%",
                  width: "8%",
                  height: "3%",
                  transform: "rotate(35deg)",
                }}
              />
            </div>
          </div>

          {/* Text side */}
          <div className="col-span-12 md:col-span-5 order-1 md:order-2">
            <p className="font-display text-[11px] uppercase tracking-[0.28em] text-foreground-700 mb-5">
              ( 04 ) — Fine Line & Gold Accent
            </p>
            <h3 className="font-display font-black text-foreground-950 leading-[0.9] tracking-[-0.04em] text-5xl md:text-6xl lg:text-7xl mb-6 md:mb-8">
              Seraphina<em className="font-serif italic font-light"> Dor</em>
            </h3>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-serif mb-10">
              Trained in the illumination arts of Paris, Seraphina creates tattoos that read like precious manuscripts on skin — delicate, luminous, sacred.
            </p>

            <ul className="border-t border-foreground-950/15 mb-10">
              {facts.map((f) => (
                <li
                  key={f.label}
                  className="flex items-baseline justify-between gap-4 border-b border-foreground-950/15 py-3"
                >
                  <span className="font-display text-[10px] uppercase tracking-[0.25em] text-foreground-700 whitespace-nowrap">
                    {f.label}
                  </span>
                  <span className="font-serif italic text-sm md:text-base text-foreground-950 text-right">
                    {f.value}
                  </span>
                </li>
              ))}
            </ul>

            <div className="flex items-end justify-between gap-6">
              <div>
                <p className="font-serif italic text-2xl md:text-3xl text-foreground-950 leading-none">
                  S. Dor
                </p>
                <p className="font-display text-[10px] uppercase tracking-[0.25em] text-foreground-700 mt-2">
                  — Artist signature
                </p>
              </div>
              <button
                onClick={handleEnter}
                className="group inline-flex items-center gap-3 cursor-pointer"
              >
                <span className="font-display text-xs uppercase tracking-[0.25em] text-foreground-950 border-b border-foreground-950/40 pb-1 group-hover:border-foreground-950 transition-colors whitespace-nowrap">
                  View Profile
                </span>
                <span className="w-9 h-9 rounded-full border border-foreground-950/30 flex items-center justify-center text-foreground-950 transition-all duration-500 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}